import { IMeshRowData } from "@pageBuilder/typings";
import { CascadeRendererBase } from "src/shared/cascade-renderer-base";
import { MeshRowRenderer } from "../mesh-row-renderer";
import { CascadeRendererFactory } from "src/shared/cascade-renderer-factory";
import { MeshColumnCascadeRenderer } from "./mesh-column-cascade-renderer";
import { IRenderingCommonContext } from "@commonRendering/types";

export class MeshRowCascadeRenderer extends CascadeRendererBase<IMeshRowData> {

    protected readonly renderer: MeshRowRenderer;

    public constructor(renderingCommonContext: IRenderingCommonContext) {
        super(renderingCommonContext);
        this.renderer = new MeshRowRenderer();
    }

    public override createByCascade(data: IMeshRowData): HTMLElement {
        const meshRowElement = this.renderer.createNew();
        this.renderer.render(meshRowElement, data);

        const columnCascadeRenderer = CascadeRendererFactory.create("MeshColumn", this.renderingCommonContext);

        data.columns?.forEach(columnData => {
            const column = columnCascadeRenderer.createByCascade(columnData);
            meshRowElement.append(column);
        });

        return meshRowElement;
    }

    public override getDataByCascade(element: HTMLElement): IMeshRowData {
        const columnCascadeRenderer = CascadeRendererFactory.create("MeshColumn", this.renderingCommonContext) as MeshColumnCascadeRenderer;
        const meshRowData = this.renderer.getData(element);

        const columns = element.querySelectorAll<HTMLElement>("[data-mesh-col]");

        meshRowData.columns = [];

        columns.forEach(columnElement => {
            const columnData = columnCascadeRenderer.getDataByCascade(columnElement);
            meshRowData.columns?.push(columnData);
        });

        return meshRowData;
    }

}
